import React from 'react'
import SvgIcon from '@mui/material/SvgIcon'

const PimIcon: React.FC = () => (
    <SvgIcon fontSize='small' viewBox='0 0 21 20'>
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M3.35742 15.2637C3.35742 16.3014 6.3555 17.1427 10.0536 17.1427C13.7522 17.1427 16.7503 16.3014 16.7503 15.2637C16.7503 14.2261 13.7522 13.3848 10.0536 13.3848C6.3555 13.3848 3.35742 14.2261 3.35742 15.2637Z'
            fill='#C7CAD4'
        />
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M3.35742 4.73584C3.35742 5.77346 6.3555 6.61474 10.0536 6.61474C13.7522 6.61474 16.7503 5.77346 16.7503 4.73584C16.7503 3.69821 13.7522 2.85693 10.0536 2.85693C6.3555 2.85693 3.35742 3.69821 3.35742 4.73584Z'
            fill='#C7CAD4'
        />
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M16.7503 9.93671C16.7503 10.9743 13.7522 11.8154 10.0539 11.8154C6.3555 11.8154 3.35742 10.9743 3.35742 9.93671C3.35742 8.89908 6.3555 8.05802 10.0539 8.05802C13.7522 8.05802 16.7503 8.89908 16.7503 9.93671Z'
            fill='#C7CAD4'
        />
    </SvgIcon>
)
export default PimIcon
